// extracted by mini-css-extract-plugin
export default {"correctAnswer":"AllQuestions_correctAnswer__RwVIx","incorrectAnswer":"AllQuestions_incorrectAnswer__5r2Ko"};